export default __webpack_public_path__ + "static/media/kitchenaid.92d28e1b.svg";